import { Text } from "@mantine/core";

interface Props {
  label: string;
  value: string;
}

export function HeldEmailDetailField({ label, value }: Props) {
  return (
    <Text size="sm">
      <Text component="span" fw={600}>
        {label}:
      </Text>{" "}
      {value}
    </Text>
  );
}
